import { inject, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  private readonly toastr = inject(ToastrService);

  handle(errorResponse: HttpErrorResponse, title: string = $localize`Error`) {
    if (errorResponse.status >= 400 && errorResponse.status < 500) {
      if (errorResponse.error?.error?.innererror?.message) {
        this.toastr.error(errorResponse.error.error.innererror.message, title);
      } else if (errorResponse.error?.error?.message) {
        this.toastr.error(errorResponse.error.error.message, title);
      } else {
        this.toastr.error($localize`Please try again later`, title);
      }
    } else if (errorResponse.status >= 500 && errorResponse.status < 600) {
      this.toastr.error($localize`Please try again later`, title);
    } else {
      this.toastr.error(title);
    }
  }
}
